import {Routes} from '@angular/router';
import {LandingPage} from './pages/landing/landing.page';
import {ChatPage} from './pages/chat/chat.page';
import {TermsPage} from './pages/terms/terms.page';

export const routes: Routes = [
  {path: '', component: LandingPage},
  {path: 'chat', component: ChatPage},
  {path: 'terms', component: TermsPage}
];
